var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex",class:{ toggled: _vm.isSidebar },attrs:{"id":"wrapper"}},[_c('app-sidebar'),_c('div',{staticStyle:{"width":"100%"},attrs:{"id":"page-content-wrapper"}},[_c('i',{staticClass:"material-icons",attrs:{"id":"menu-toggle"},on:{"click":function($event){_vm.isSidebar =  !_vm.isSidebar}}},[_vm._v("view_headline")]),_c('app-navbar'),_c('div',{staticClass:"container-fluid mt-5"},[_c('div',{staticClass:"col-sm-12 print-media"},[_c('vs-breadcrumb',{attrs:{"align":"left","items":[
                  {title: 'You are here : '},
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/Admin/adminDashboard',
                  },
                  {
                    title: 'Event Brief Report',
                    url: '/#/dashboard/Admin/trainingBriefReport',
                    active: true
                  }
                ]}})],1),_c('BriefReportAdmin')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }